export const BRAND = {
  name: "Clima Oliver",
  logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_9490c2e0-651c-4bc7-9cb1-c897eee6a777/artifacts/9fhc7s3f_64B6EEB9-8BA5-4E1A-BCDA-72F7D6020473.jpeg",
  whatsapp: "34633072686",
  whatsappDisplay: "+34 633 07 26 86",
  founded: 2021,
  ceo: "David de Oliveira",
  founder: "Cleverson Elvis",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
